/* eslint-disable */
import React, { Component } from "react";
import styles from "../../assets/css/modules/health-store/centred-content-hero.css";
import Content from "../../content/Content";
import StyledButton from "../shared/buttons/StyledButton";
import Button from "../shared/buttons/Button";
import layoutStyle from "../../assets/css/modules/shared/layout.css";
import ImageHeroContainer from "../shared/containers/ImageHeroContainer";
import Popup from "reactjs-popup";
import ModalPopup from "../shared/ModalPopup";
import SmartLink from "../shared/links/SmartLink";
import { Paths } from "../../constants/UrlConstants";
import { Urls } from "../../constants/UrlConstants";
import { Link } from "react-router-dom";
import { Layouts,ButtonConfig } from "../../constants/Constants";
import btnStyles from "../../assets/css/modules/health-support/ask-a-medical-expert.css";

// const parent={
//   display:'flex',
//   marginLeft:'-17px',
// };


 

const child ={
  float: 'left',
  marginRight:'7px'
};

// const buttonchildLink ={
//   float: 'left',
//   paddingLeft:'60px',
// }; 

const childLinkText ={
  float: 'left',
  paddingLeft:'2px',
  marginTop:'0px',
  fontSize:'17px',
  color:'#00008F',
}; 
export default class CenteredContentHero extends Component {
  
  onBookAppointmentClick() {
    window.open(Urls.AxaBookappointmentUrl, "_blank");
  }
  onServiceClick (){
    window.open(Urls.DCAMembersAXA, "_blank");
  }  
  render() {
    return (
      <ImageHeroContainer
        bgImage={this.props.Content.HomeHeroBGSrc}
        bgImageMobile={this.props.Content.HomeHeroBGSrcMobile}
        bgImageTablet={this.props.Content.HomeHeroBGSrcTablet}
        bgAlt=""
        UniqueKey={this.props.UniqueKey}
      >
        {this.props.Content.ActivePlusClosing ? (
          <div className={styles.activePlusClosing}>
            <Content name={this.props.Content.ActivePlusClosing} />
          </div>
        ) : null}
        <h1>
          <Content name={this.props.Content.Heading} />
        </h1>
        <Content name={this.props.Content.Description} />
        {this.props.ShowGp === false  && (<React.Fragment> 
        {/* <div style={parent}>
          <div className="col-lg-3" > */}
          <div className={"container " + btnStyles.buttonRowSpacing}>
            <div className="row">
              <div className="col-lg-12 p-0">
                <div className={styles.gpButton}>
                  <StyledButton
                    id={ButtonConfig.Setupthisservice}
                    label={this.props.Content.Setupthisservice}
                    buttonType={this.props.Content.Layout === Layouts.MOL ? "primaryBlueButton" : "secondaryOrangeButtonSupportDCA"}
                    onClick={this.onServiceClick}
                    Healthsupportline1='Healthsupportline'
                    layout={this.props.Content.Layout}
                    buttonColor='blue'
                  />
                  {/* </div>
          <div className="col-lg-3" > */}
                  <StyledButton
                    id={ButtonConfig.BookanAppoint}
                    label={this.props.Content.BookanAppointment}
                    buttonType={this.props.Content.Layout === Layouts.MOL ? "secondaryBlueButton" : "secondaryOrangeButton"}
                    onClick={this.onBookAppointmentClick}
                    layout={this.props.Content.Layout}
                    Healthsupportline1='Healthsupportline'
                    buttonColor='White'
                  />
                </div>
              </div>
            </div>
          </div>
        <div className="parentText">
          <div style={child}><p>Seeking help for a muscle, bone or joint problem?  </p></div>
          <div style={childLinkText}>            
              <Link style={{ fontSize: "18px" }}
                id={ButtonConfig.SpeakToanExpert}
                className={layoutStyle.anchorDecorationUnderline}
                to={Paths.WorkingBody} >
                {'    '+'Speak to an expert fast'}
              </Link>
          </div>
        </div> 
        </React.Fragment>)}

        <div className={styles.rightResponsiveButton}>
          {this.props.Content.LinkTo && this.props.ShowGp === true ? (
            <Content name={this.props.Content.LinkTo}>
              {(link) => (
                <SmartLink
                  to={link}
                  isExternalLink={this.props.isExternalLink}
                  className={"btn " + styles.btnPrimary + " btnSubmitPrimary"}
                >
                  <Content name={this.props.Content.ButtonText} />
                </SmartLink>
              )}
            </Content>
          ) : null}
          {this.props.Content.ExternalLinkTo && this.props.ShowGp === true ? (
            <Content name={this.props.Content.ExternalLinkTo}>
              {(link) => (
                <Button
                  label={<Content name={this.props.Content.ButtonText} />}
                  onClick={this.props.onButtonClick}
                />
              )}
            </Content>
          ) : null}
        </div>
        {this.props.isPopupOpen ? (
          <Popup
            open={this.props.isPopupOpen}
            modal
            onClose={this.props.closePopup}
          >
            <ModalPopup
              cancel={this.props.closePopup}
              continue={this.props.continuePopup}
              heading={this.props.Content.ModalHeading}
              description={this.props.Content.ModalDescription}
              backlink={this.props.Content.ModalBackLink}
            />
          </Popup>
        ) : null}
      </ImageHeroContainer>
    );
  }
}
